import styled from 'styled-components';

import ValidationCheck from '@/components/atom/icon/ValidationCheck';
import { NON_BENEFIT_INFORMATIONS } from '@/constants/nonBenefit';
import { NonBenefitMedicine } from '@/models/nonBenefit';

interface Props {
  selectedMedicine: NonBenefitMedicine;
}
const NonBenefitCategoryInformation = ({ selectedMedicine }: Props) => {
  if (!NON_BENEFIT_INFORMATIONS[`${selectedMedicine.id}`]) {
    return null;
  }

  return (
    <CategoryInformationArticle>
      <CategoryInformationHeader>
        <CategoryInformationTitle>{`${selectedMedicine.treatmentProductMedicineName} 처방 받기 전 체크리스트`}</CategoryInformationTitle>
      </CategoryInformationHeader>
      <CategoryInformationContent>
        <CategoryInformationList>
          {NON_BENEFIT_INFORMATIONS[`${selectedMedicine.id}`].map((information) => (
            <CategoryInformationListItem key={`non-benefit-category-info-${selectedMedicine.id}-${information.title}`}>
              <IconWrapper>
                <ValidationCheck />
              </IconWrapper>
              <InformationDetailWrapper>
                <InformationTitle>{information.title}</InformationTitle>
                <InformationContent
                  dangerouslySetInnerHTML={{
                    __html: information.description,
                  }}
                />
              </InformationDetailWrapper>
            </CategoryInformationListItem>
          ))}
        </CategoryInformationList>
      </CategoryInformationContent>
    </CategoryInformationArticle>
  );
};

export default NonBenefitCategoryInformation;

const CategoryInformationArticle = styled.article``;

const CategoryInformationHeader = styled.div`
  padding: 16px 0;
`;

const CategoryInformationTitle = styled.h2`
  padding: 16px 24px 8px;
  white-space: pre-line;
  ${({ theme }) => theme.typography.UI22SB};
  color: ${({ theme }) => theme.color.gray700};
`;

const CategoryInformationContent = styled.div`
  padding: 0 24px 12px;
`;

const CategoryInformationList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const CategoryInformationListItem = styled.li`
  display: flex;
  gap: 12px;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px;
  width: 22px;
  height: 22px;
`;

const InformationDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InformationTitle = styled.h3`
  ${({ theme }) => theme.typography.UI17SB};
  color: ${({ theme }) => theme.color.gray600};
`;

const InformationContent = styled.div`
  & ul {
    margin-top: 8px;
    & > li {
      position: relative;
      ${({ theme }) => theme.typography.UI15R};
      color: ${({ theme }) => theme.color.gray400};
      list-style: none;
      margin-left: 20px;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: -10px;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.color.gray400};
        transform: translate(-3px, -50%);
      }
    }
  }
  & p {
    ${({ theme }) => theme.typography.UI15R};
    color: ${({ theme }) => theme.color.gray400};
  }
`;
